import { baseURLGetPages } from "../config/api";
import React, { useState, useEffect } from "react";
export default function PagePanel() {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPages = async () => {
      try {
        const response = await fetch(baseURLGetPages);
        const data = await response.json();
        setPages(data);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchPages();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }
  console.log(`pages`, pages);
  return (
    <div>
      <h1>Pages</h1>
      <ul>
        {pages.map((page) => (
          <li key={page.id}>{page.EnTitle}</li>
        ))}
      </ul>
    </div>
  );
}
